import React from "react"
import { Field } from "formik"
import { TextField } from "@material-ui/core"
import PropTypes from "prop-types"

const DatePicker = props => {
  const { name, ...rest } = props
  const variant = rest.variant ? rest.variant : "outlined"
  return (
    <>
      <Field name={name} id={name} {...rest}>
        {fieldProps => {
          const { field, meta } = fieldProps
          return (
            <TextField
              error={Boolean(meta.touched && meta.error)}
              fullWidth
              helperText={meta.error}
              {...rest}
              title={name}
              margin="normal"
              variant={variant}
              name={field.name}
              onBlur={field.onBlur}
              onChange={field.onChange}
              value={field.value || ""}
              // {...field} // replaces name, value, onChange and onBlur
              id={name}
              InputLabelProps={{
                shrink: true
              }}
            />
          )
        }}
      </Field>
    </>
  )
}

DatePicker.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.string,
  props: PropTypes.object
}

export default DatePicker
